import { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
//
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { IoIosStats } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import { PlaceholderButton } from "../../Components/Placeholders.jsx";
import Table from "../../Components/Table/Table.js";
import ToolTip from "../../Components/ToolTip.js";
import ThemeSpinner from "../../Components/general/ThemeSpinner.jsx";
import { useGetAllSubGamesByGameSlugQuery, useGetGameUsersStatsByGameSlugQuery } from "../../store/apis/gameApi.js";
import { BackButton, SubTitle } from "../../Components/index.js";

const GameUsersStatsScreen = () => {
    const params = useParams()
    const navigate = useNavigate()
    const {
        control,
        formState: { errors },
    } = useForm({ mode: "onChange" });

    const [indicationMessage, setIndicationMessage] = useState("loading...");

    const [apiData, setApiData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

    const [searchQuery, setSearchQuery] = useState("");

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);


    const { data, isSuccess, isLoading, refetch } =
        useGetGameUsersStatsByGameSlugQuery({ slug: params.slug, params: { page: currentPage, limit: pageSize } }, { refetchOnMountOrArgChange: true });

    const handleTableChange = (type, { page, sizePerPage }) => {
        setCurrentPage(page);
        setPageSize(sizePerPage);
    };


    useEffect(() => {
        if (isSuccess && data?.data) {
            setApiData(data.data); // Save raw API data
            setFilteredData(data.data); // Initially same as raw

            if (data.data.length === 0) {
                setIndicationMessage("Data not available");
            }
        }
    }, [data, isSuccess]);

    useEffect(() => {
        const lowerQuery = searchQuery.toLowerCase();
        const results = apiData.filter((item) =>
            item?.user?.full_name?.toLowerCase().includes(lowerQuery)
        );
        if (results.length === 0) {
            setIndicationMessage("Data not found.")
        }
        setFilteredData(results);
    }, [searchQuery, apiData]);


    function indication() {
        return indicationMessage;
    }

    const columns = [
        {
            dataField: "user.full_name",
            text: "Username",
            sort: true,
            headerStyle: {
                // width: "150px",
            },
        },

        {
            dataField: "coins_won",
            text: "Coins Won",
            sort: true,
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "150px",
            },
            formatter: (cellContent, row) => {
                return (
                    <p>{row.coins_won}</p>
                );
            },
        },
        {
            dataField: "coins_loss",
            text: "Coins Loss",
            sort: true,
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "150px",
            },
            formatter: (cellContent, row) => {
                return (
                    <p>{row.coins_loss}</p>
                );
            },
        },
        {
            dataField: "tickets_won",
            text: "Tickets Won",
            sort: true,
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "150px",
            },
            formatter: (cellContent, row) => {
                return (
                    <p>{row.tickets_won}</p>
                );
            },
        },
        {
            dataField: "tickets_loss",
            text: "Tickets Loss",
            sort: true,
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "150px",
            },
            formatter: (cellContent, row) => {
                return (
                    <p>{row.tickets_loss}</p>
                );
            },
        },
        {
            dataField: "actions",
            text: "Actions",
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "200px",
            },
            formatter: (cellContent, row) => {
                // console.log(row)
                if (row.slug) {
                    return (
                        <div className="d-flex justify-content-center align-items-center ">
                            <ToolTip placement={"top"} content={"View Stats"}>
                                <div
                                    className="d-flex justify-content-center align-items-center bg-red-hover rounded-3 p-2 mx-2"
                                    role="button"
                                // onClick={() => navigate(`/admin/game/${GAME_SLUG}/${row.slug}/stats`)}
                                >
                                    <span className={`d-flex align-items-center pe-1`}>
                                        <IoIosStats size={22} />
                                    </span>
                                </div>
                            </ToolTip>
                        </div>
                    );
                }
            },
        },
    ];

    return (
        <div className="MainContainer">
            <div className="headerContainer">
                <Row className="w-100 align-items-center">
                    <Col md={6}>
                        <div className="d-flex flex-row align-items-center gap-3 text-white">
                            <BackButton isRelative={true} />
                            <SubTitle text={params.slug.replace('-', ' ') + ' Users'} classes="text-capitalize" />
                        </div>
                    </Col>

                    <Col md={6}>
                        {
                            isLoading ?
                                <PlaceholderButton />
                                :
                                <Controller
                                    name="search"
                                    control={control}
                                    render={({ field }) => (
                                        <>
                                            <Form.Control
                                                {...field}
                                                placeholder="Search by name"
                                                type="text"
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                            />
                                        </>
                                    )}
                                />}
                    </Col>
                </Row>
            </div>

            <div className="mainTable">
                {isLoading ? (
                    <ThemeSpinner />
                ) : (
                    <Table
                        // classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
                        key={data?.pagination?.total_records}
                        data={filteredData || []}
                        columns={columns}
                        indication={indication}
                        isRemotePagination={true}
                        totalRecords={data?.pagination?.total_records || 0}
                        currentPage={currentPage}
                        pageSize={pageSize}
                        refetch={handleTableChange}
                    />
                )}
            </div>
        </div>
    );
};

export default GameUsersStatsScreen;
